<template>
	<div style="padding: 10px 0;">
		<div v-for="(item, idx) in certList" :key="idx"
			style="margin-bottom: 16px; position: relative; padding: 12px; border: 1px solid #e8e8e8; border-radius: 4px;">
			<!-- 删除该资质 -->
			<a-icon type="close-circle"
				style="position: absolute; top: 8px; right: 8px; font-size: 20px; color: #f5222d; cursor: pointer; z-index: 10;"
				@click="deleteItem(idx)" />
			<!-- 分布名称 -->
			<a-form layout="inline" style="margin-bottom: 8px;">
				<a-form-item label="分布名称">
					<a-input v-model="item.brandLine" placeholder="分布名称" style="width: 200px" @input="syncParent" />
				</a-form-item>
			</a-form>

			<!-- 上传图片 -->
			<a-form layout="inline">
				<a-form-item label="上传图片">
					<div>
						<div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
							<div v-if="item.factoryImages" style="position: relative;">
								<img :src="item.factoryImages" style="width: 80px; height: 80px; object-fit: cover; cursor: pointer;"
									@click="preview(item.factoryImages)" title="点击放大查看" />
								<div style="position: absolute; top: -8px; right: -8px; background: red; color: white;
              width: 20px; height: 20px; border-radius: 50%; text-align: center;
              line-height: 18px; cursor: pointer;" @click="delImage(item)">×</div>
							</div>

							<!-- 图片上传 input -->
							<input type="file" accept=".jpg,.jpeg,.png" @change="handleFile($event, item, idx)"
								style="display: none;" :ref="'cert_file_' + idx" />
							<div v-if="uploadLoading[idx]" style="width: 80px; height: 80px; border: 1px dashed #ccc;
            display: flex; align-items: center; justify-content: center;">
								<a-icon type="loading" style="font-size: 24px; color: #1890ff;" />
							</div>
							<div v-else @click="$refs['cert_file_' + idx][0].click()" style="width: 80px; height: 80px; border: 1px dashed #ccc;
            display: flex; align-items: center; justify-content: center; cursor: pointer;">
								<a-icon type="plus" />
							</div>
						</div>
						<div style="color: #999; font-size: 12px; margin-top: 4px;">只能上传jpg/png格式文件，单文件不能超过3M</div>
					</div>
				</a-form-item>
			</a-form>
		</div>

		<a-button type="primary" @click="addItem" style="margin-top: 10px;">
			+ 添加项（资质）
		</a-button>

		<!-- 图片预览弹窗 -->
		<a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" width="auto" centered>
			<img :src="previewImage" style="max-width: 80vw; max-height: 80vh;" />
		</a-modal>
	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../../utils/oss";
	export default {
		props: {
			errors: {
				type: Array,
				default: () => []
			},
			value: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				certList: [],
				uploadLoading: {},
				previewVisible: false,
				previewImage: ''
			};
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler(val) {
					this.certList = val.map(item => ({
						factoryEnvironmentId: item.factoryEnvironmentId || null,
						factoryLangId: item.factoryLangId || null,
						brandLine: item.brandLine || '',
						factoryImages: item.factoryImages || '',
						factoryEnvironmentType: 'CERT',
					}));
				}
			}
		},
		methods: {
			addItem() {
				this.certList.push({
					factoryEnvironmentId: null,
					factoryLangId: null,
					brandLine: '',
					factoryImages: '',
					factoryEnvironmentType: 'CERT'
				});
				this.syncParent();
			},

			deleteItem(idx) {
				this.certList.splice(idx, 1);
				this.syncParent();
			},

			delImage(item) {
				item.factoryImages = '';
				this.syncParent();
			},

			preview(url) {
				this.previewImage = url;
				this.previewVisible = true;
			},

			async handleFile(e, item, idx) {
				if (!e.target.files.length) return;
				const file = e.target.files[0];
				const ext = file.name.split('.').pop().toLowerCase();
				if (!['jpg', 'jpeg', 'png'].includes(ext)) {
					this.$message.warning('只能上传jpg/png格式文件');
					e.target.value = '';
					return;
				}
				if (file.size > 3 * 1024 * 1024) {
					this.$message.warning('图片大小不能超过3M');
					e.target.value = '';
					return;
				}
				this.$set(this.uploadLoading, idx, true);
				ossUpload(file, '', 'image/')
					.then((res) => {
						item.factoryImages = res.url;
						this.syncParent();
						e.target.value = "";
						this.$set(this.uploadLoading, idx, false);
					})
					.catch(() => {
						this.$message.error('图片上传失败');
						this.$set(this.uploadLoading, idx, false);
					});
			},

			syncParent() {
				const result = this.certList.map(item => ({
					factoryEnvironmentId: item.factoryEnvironmentId,
					factoryLangId: item.factoryLangId,
					brandLine: item.brandLine,
					factoryImages: item.factoryImages,
					factoryEnvironmentType: 'CERT'
				}));
				this.$emit("input", result);
			}
		}
	};
</script>
